export default __webpack_public_path__ + "static/media/Animals-23.fa6e70ad.png";